<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.withTime = $event.withTime'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}
                .form__field-body
                    cs-multiselect(
                        :options="groups"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.selectedGroups"
                        :disabled="groups.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="groups"
                        :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                        class="multiple-multiselect"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.amountOfRows",
                        :max="20",
                        :min="3",
                        @increase="params.amountOfRows++",
                        @decrease="params.amountOfRows--",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsToRemember') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.amountOfWords",
                        :max="15",
                        :min="2",
                        @increase="params.amountOfWords++",
                        @decrease="params.amountOfWords--",
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_invertedWords') }}
                .form__field-body
                    cs-checkbox(
                        v-model='params.invertedWords',
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="params.selectedGroups.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedGroups.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedGroups.length < 1")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import WordFieldReadingEnApi from '../../../api/games/wordsFieldReadingEn';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_wordsFieldWithoutTime'),
                        withTime: false
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_wordsFieldWithTime'),
                        withTime: true
                    }
                ],
                seconds: IntervalConfig.secondsForMemoryGames,
                selectedGameType: null,
                groups: [],
                params: null,
            }
        },
        mounted() {
            this.getGroups();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        methods: {
            getGroups() {
                WordFieldReadingEnApi.getGroups(this.user.locale).then(data => {
                    this.groups = data;
                })
            },
            secondsLabel (second) {
                return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            }
        },
        updated () {
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
        },
        watch: {
            'params.withTime': {
                handler (val) {
                    !this.params.showTime && val && (this.params.showTime = this.seconds[0]);
                    !val && (this.params.showTime = null);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

